<template>
  <div class="article-container">
    <!-- 搜索区域 -->
    <div class="search-container">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="文章标题">
          <el-input v-model="searchForm.title" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-form-item label="发布时间">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="文章标签">
          <el-select
            v-model="searchForm.tags"
            filterable
            placeholder="请选择标签"
            style="width: 180px">
            <el-option
              v-for="tag in tags"
              :key="tag._id"
              :label="tag.tag"  
              :value="tag.tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 操作按钮 -->
    <div class="operation-container">
      <el-button type="primary" @click="handleAdd">新增文章</el-button>
    </div>

    <!-- 表格区域 -->
    <div class="table-container">
      <el-table
        :data="tableData"
        style="width: 100%"
        stripe
        v-loading="loading">
        <el-table-column
          prop="_id"
          label="ID"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="title"
          label="文章标题"
          align="center"
         >
        </el-table-column>
        <el-table-column
          prop="publishTime"
          label="发布时间"
          :formatter="formatPublishTime"
          align="center"
         >
        </el-table-column>
        <el-table-column
        align="center"
          label="缩略图">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 60px"
              :src="imageUrl + scope.row.thumbnail"
              fit="cover"
              :preview-src-list="[imageUrl+scope.row.thumbnail]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
        align="center"
          prop="tags"
          label="标签"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
           
            <el-tag> {{ scope.row.tags || '无标签' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
        align="center"
          label="操作"
          >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[5]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :width="dialogWidth" @close="resetForm">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="文章标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="publishTime">
          <el-date-picker
            v-model="form.publishTime"
            type="datetime"
            placeholder="选择发布时间"
            value-format="yyyy-MM-dd HH:mm:ss">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="文章标签" prop="tags">
          <el-select
            v-model="selectedTag"  
            filterable
            placeholder="请选择标签"
            style="width: 100%">
            <el-option
              v-for="tag in tags"
              :key="tag._id"
              :label="tag.tag"  
              :value="tag.tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缩略图" prop="thumbnail">
          <el-upload
          class="avatar-uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="handleThumbnailChange"
          :before-upload="beforeAvatarUpload">
          <!-- <img 
            v-if="form.thumbnail" 
            :src="isEditMode ? imageUrl + form.thumbnail : form.thumbnail" 
            class="avatar"> -->
            <img 
              v-if="form.thumbnail" 
              :src="isLocalPath(form.thumbnail) ? form.thumbnail : imageUrl + form.thumbnail" 
              class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        </el-form-item>
        <el-form-item label="文章内容" prop="content">
          <div id="editor" style="border: 1px solid #ccc; margin-top: 10px; min-height: 300px;"></div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="uploading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import E from 'wangeditor'

export default {
  name: 'ArticleManagement',
  data() {
    return {
      searchForm: {
        title: '',
        dateRange: [],
        tags: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 5,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增文章',
      form: {
        _id: '',
        title: '',
        publishTime: '',
        thumbnail: '',
        content: '',
        tags: ''
      },
      rules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        publishTime: [
          { required: true, message: '请选择发布时间', trigger: 'change' }
        ],
        tags: [
          { required: true, message: '请选择标签', trigger: 'change' }
        ],
        thumbnail: [
          { required: true, message: '请上传缩略图', trigger: 'change' }
        ],
        content: [
          { required: true, message: '请输入文章内容', trigger: 'blur' }
        ]
      },
      editor: null,
      isEditorInitialized: false,
      thumbnailFile: null,
      editorImages: [],
      uploading: false,
      tags: [],          // 所有标签列表
      selectedTag: '',   // 当前选中的单个标签ID
      isTagLoaded: false, // 标签是否加载完成
        // 响应式相关数据
        screenWidth: window.innerWidth
    }
  },
    computed: {
    // 判断当前是否为编辑模式
    isEditMode() {
      return this.dialogTitle === '编辑文章';
    },
     // 判断是否为桌面设备
     isDesktop() {
      return this.screenWidth >= 1024;
    },
    // 对话框宽度
    dialogWidth() {
      return this.screenWidth < 768 ? '100%' : '35%';
    }
  },
  watch: {
    selectedTag(newVal) {
      this.form.tags = newVal;
    }
  },
  mounted() {
    this.fetchData()
    this.fetchTags() // 加载标签数据
     // 监听窗口大小变化
     window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    this.destroyEditor()
  },
  methods: {
     // 处理窗口大小变化
     handleResize() {
      this.screenWidth = window.innerWidth;
    },
    isLocalPath(url) {
    return url.startsWith('data:') || url.startsWith('blob:');
  },
    // 格式化表格中的发布时间
    formatPublishTime(row, column) {
      if (!row.publishTime) return '';
      const date = new Date(row.publishTime);
      return date.toLocaleString();
    },
    
    // 初始化富文本编辑器
    initEditor() {
      this.destroyEditor()
      
      this.$nextTick(() => {
        this.editor = new E('#editor')
        
        // 自定义上传图片
        this.editor.config.customUploadImg = (resultFiles, insertImgFn) => {
          this.editorImages = [...this.editorImages, ...resultFiles]
          resultFiles.forEach(file => {
            const reader = new FileReader()
            reader.onload = (e) => {
              insertImgFn(e.target.result)
            }
            reader.readAsDataURL(file)
          })
        }
        
        this.editor.config.onchange = (html) => {
          this.form.content = html
        }
        this.editor.create()
        
        if (this.form.content) {
          this.editor.txt.html(this.form.content)
        }
        
        this.isEditorInitialized = true
      })
    },
    
    // 销毁编辑器
    destroyEditor() {
      if (this.editor) {
        this.editor.destroy()
        this.editor = null
      }
      this.isEditorInitialized = false
    },
    
    // 加载标签列表
    fetchTags() {
      this.$http.get('/api/tags')
        .then(response => {
          if (response.data.code === 200) {
            console.log('标签数据:', response.data.data.list);
            this.tags = response.data.data.list || [];
            this.isTagLoaded = true;
          } else {
            this.$message.error(response.data.message || '获取标签列表失败');
          }
        })
        .catch(error => {
          this.$message.error('获取标签列表失败');
          console.error(error);
        });
    },
    
    // 获取文章列表
    fetchData() {
      this.loading = true;
      const params = {
        title: this.searchForm.title,
        dateRange: this.searchForm.dateRange,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        tags: this.searchForm.tags
      };
      
      this.$http.get('/api/articles', { params })
        .then(response => {
          if (response.data.code === 200) {
            console.log('文章数据:', response.data.data.list);
            this.tableData = response.data.data.list;
            this.pagination.total = response.data.data.total;
          } else {
            this.$message.error(response.data.message || '获取文章列表失败');
          }
        })
        .catch(error => {
          this.$message.error('获取文章列表失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        title: '',
        dateRange: [],
        tags: ''
      };
      this.handleSearch();
    },
    
    // 新增文章
    handleAdd() {
      this.dialogTitle = '新增文章';
      this.dialogVisible = true;
      this.selectedTag = ''; // 重置选中的标签
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    
    // 编辑文章
    handleEdit(index, row) {
      this.dialogTitle = '编辑文章';
      this.form = {
        _id: row._id,
        title: row.title,
        // 关键修改：将publishTime转换为Date对象
        publishTime: this.formatToDate(row.publishTime),
        thumbnail: row.thumbnail || '',
        content: row.content,
        tags: row.tags || '' // 直接使用标签字符串
      };
      
      // 初始化选中的标签（如果有）
      this.selectedTag = this.form.tags || '';
      
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.initEditor();
      });
    },
    
    // 将各种格式的日期转换为Date对象
    formatToDate(dateValue) {
      if (!dateValue) return null;
      
      // 如果已经是Date对象，直接返回
      if (dateValue instanceof Date) return dateValue;
      
      // 尝试将字符串转换为Date
      if (typeof dateValue === 'string') {
        // 处理ISO格式 (YYYY-MM-DDTHH:mm:ss)
        if (dateValue.includes('T')) {
          return new Date(dateValue);
        }
        
        // 处理"YYYY-MM-DD HH:mm:ss"格式
        const parts = dateValue.split(/[- :T]/);
        if (parts.length >= 6) {
          return new Date(
            parseInt(parts[0]),
            parseInt(parts[1]) - 1, // 月份从0开始
            parseInt(parts[2]),
            parseInt(parts[3]),
            parseInt(parts[4]),
            parseInt(parts[5])
          );
        }
        
        // 尝试其他格式
        return new Date(dateValue);
      }
      
      // 尝试将数字转换为Date（时间戳）
      if (typeof dateValue === 'number') {
        return new Date(dateValue);
      }
      
      return null;
    },
    
    // 将Date对象格式化为字符串
    formatDateToString(date) {
      if (!date) return '';
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 删除文章
    handleDelete(index, row) {
      this.$confirm('确认删除该文章吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/api/articles/${row._id}`)
          .then(response => {
            if (response.data.code === 200) {
              this.$message.success('删除成功');
              this.fetchData();
            } else {
              this.$message.error(response.data.message || '删除失败');
            }
          })
          .catch(() => {
            this.$message.error('删除失败');
          });
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchData();
    },
    
    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchData();
    },
    
    // 缩略图选择变化
    handleThumbnailChange(file) {
      const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
      const isLt5M = file.raw.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
        return false;
      }
      
      this.thumbnailFile = file.raw;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.form.thumbnail = e.target.result;
      };
      reader.readAsDataURL(file.raw);
      return false;
    },
    
    // 图片上传前校验
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/PNG 格式!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isJPG && isLt5M;
    },
    
    // 上传单个图片
    async uploadImage(file) {
      const formData = new FormData();
      formData.append('file', file);
      
      try {
        const response = await this.$http.post('/api/articles/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        if (response.data.code === 200) {
          return response.data.data.url;
        } else {
          throw new Error(response.data.message || '上传失败');
        }
      } catch (error) {
        console.error('上传图片失败:', error);
        this.$message.error('上传图片失败');
        throw error;
      }
    },
    
    // 提交表单
    async submitForm() {
      try {
        const valid = await this.$refs.form.validate();
        if (!valid) return;
        
        this.uploading = true;
        
        // 直接使用selectedTag作为标签字符串
        this.form.tags = this.selectedTag;
        
        // 上传缩略图
        if (this.thumbnailFile) {
          this.form.thumbnail = await this.uploadImage(this.thumbnailFile);
        }
        
        // 上传富文本编辑器中的图片并替换URL
        if (this.editorImages.length > 0) {
          const uploadPromises = this.editorImages.map(file => {
            return this.uploadImage(file).then(serverUrl => {
              const tempUrl = URL.createObjectURL(file);
              return { tempUrl, serverUrl };
            });
          });
          
          const results = await Promise.all(uploadPromises);
          
          let content = this.form.content;
          results.forEach(({ tempUrl, serverUrl }) => {
            content = content.replace(tempUrl, serverUrl);
          });
          this.form.content = content;
        }
        
        // 关键修改：将publishTime转换为字符串格式
        if (this.form.publishTime instanceof Date) {
          this.form.publishTime = this.formatDateToString(this.form.publishTime);
        }
        
        // 提交表单数据
        const url = this.dialogTitle === '新增文章' 
          ? '/api/articles' 
          : `/api/articles/${this.form._id}`;
        const method = this.dialogTitle === '新增文章' ? 'post' : 'put';
        
        const payload = {
          title: this.form.title,
          publishTime: this.form.publishTime,
          thumbnail: this.form.thumbnail,
          content: this.form.content,
          tags: this.form.tags
        };
        console.log('提交的数据', payload);
        
        const response = await this.$http[method](url, payload);
        
        if (response.data.code === 200) {
          this.$message.success(this.dialogTitle === '新增文章' ? '新增成功' : '修改成功');
          this.dialogVisible = false;
          this.fetchData();
        } else {
          this.$message.error(response.data.message || '操作失败');
        }
      } catch (error) {
        console.error('提交表单失败:', error);
        if (!error.response) {
          this.$message.error('操作失败');
        }
      } finally {
        this.uploading = false;
      }
    },
    
    // 重置表单
    resetForm() {
      this.$refs.form.resetFields();
      this.form = {
        _id: '',
        title: '',
        publishTime: '',
        thumbnail: '',
        content: '',
        tags: ''
      };
      this.selectedTag = '';
      this.thumbnailFile = null;
      this.editorImages = [];
      this.destroyEditor();
    }
  }
}
</script>

  <style scoped>


    
    /* 搜索区域响应式 */
    .search-container {
      margin-bottom: 20px;
      padding: 20px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    
    .search-form {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
      gap: 16px;
      align-items: start;
    }
    
    .search-form .el-form-item {
      margin-bottom: 0;
      margin-right: 0;
    }
    
    .search-form .el-form-item__label {
      width: auto !important;
      padding-right: 10px;
    }
    
    .search-form .el-form-item__content {
      flex: 1;
    }
    
    .search-actions {
      display: flex;
      gap: 10px;
      justify-content: flex-start;
      grid-column: 1 / -1;
    }
    
    /* 操作按钮区域响应式 */
    .operation-container {
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-start;
    }
    
    /* 表格区域响应式 */
    .table-container {
      margin-bottom: 20px;
      background: #fff;
      border-radius: 4px;
      overflow: hidden;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      width: 100%;
      overflow-x: auto;
    }
    
    .el-table {
      min-width: 700px;
    }
    
    .el-table .hidden-columns {
      display: none;
    }
    
    .el-table .mobile-column {
      display: none;
    }
    
    .el-tag {
      margin: 2px;
    }
    
    /* 分页响应式 */
    .pagination-container {
      display: flex;
      justify-content: center;
      padding: 10px 0;
    }
    
    /* 对话框响应式 */
    .el-dialog {
      max-width: 95vw !important;
    }
    
    .el-dialog__body {
      padding: 20px;
    }
    
    .el-form-item__content > .el-select {
      width: 100%;
    }
    
    /* 图片上传样式 */
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 178px;
    }
    
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100%;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    
    .avatar {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
    }
    
    /* 编辑器样式 */
    #editor {
      min-height: 300px;
      z-index: 100;
    }
    
    /* 移动设备适配 */
    @media screen and (max-width: 992px) {
      .article-container {
        padding: 12px;
      }
      
      .search-container {
        padding: 16px;
      }
      
      .search-form {
        grid-template-columns: 1fr;
        gap: 12px;
      }
      
      .search-actions {
        grid-column: 1;
      }
      
      .el-dialog__wrapper .el-dialog {
        width: 95% !important;
      }
    }
    
    @media screen and (max-width: 768px) {
      .el-range-editor.el-input__inner {
        width: auto !important;
      }
      .el-dialog {
        width: 100%;
      }
      .article-container {
        padding: 8px;
      }
      
      .search-container {
        padding: 12px;
      }
      
      .el-table th, 
      .el-table td {
        padding: 8px 0;
      }
      
      .el-table .el-button {
        padding: 6px 8px;
        font-size: 12px;
      }
      
      .el-pagination__jump {
        display: none !important;
      }
      
      .el-pagination__sizes {
        display: none !important;
      }
    }
    
    @media screen and (max-width: 576px) {
   
     
      .article-container {
        padding: 5px;
      }
      
      .search-container {
        padding: 10px;
      }
      
      .operation-container .el-button {
        width: 100%;
      }
      
      .search-actions {
        flex-direction: column;
      }
      
      .search-actions .el-button {
        width: 100%;
        margin-left: 0 !important;
      }
      
      .el-table .default-column {
        display: none;
      }
      
      .el-table .mobile-column {
        display: table-cell;
      }
      
      .el-dialog__wrapper .el-dialog {
        margin: 5px !important;
        width: calc(100vw - 10px) !important;
      }
      
    }
  </style>